import { REQUEST_FACEBOOK_POST_BY_TYPE_SUCCESS, REQUEST_FACEBOOK_POST_BY_TYPE_ERROR } from '../constants/actionTypes';

const INITIAL_STATE = { posts: [], errors: null };

export default function facebookPostByTypeReducer(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case REQUEST_FACEBOOK_POST_BY_TYPE_SUCCESS:
      return { ...state, posts: action.payload.data, errors: null }
    case REQUEST_FACEBOOK_POST_BY_TYPE_ERROR:
      return { ...state, posts: [], errors: action.payload.response && action.payload.response.data.errors }
    default:
      return state;
  }
}
